export class VehiclePosition {
  constructor(public latitude: number, public longitude: number) { }
}
